import React from 'react'
import PropTypes from 'prop-types'
import {convertStrongTags} from '#tools/convertTaggedText'

class StyledUnorderedList extends React.Component {
  render() {
    const listelements = this.props.items.map((item, index) =>
      React.createElement('li', {key: index.toString()}, ...convertStrongTags(item)),
    )

    return <ul className="unorderedlist">{listelements}</ul>
  }
}

StyledUnorderedList.propTypes = {
  items: PropTypes.array,
}

export default StyledUnorderedList
